import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/App';
import { Mail, Lock, Eye, EyeOff } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { toast } from 'sonner';

const LOGO_URL = "/logo-adegga.png";

const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const from = location.state?.from?.pathname || '/app/dashboard';

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      toast.error('Preencha todos os campos');
      return;
    }

    setLoading(true);
    try {
      const user = await login(email, password);
      toast.success(`Bem-vindo, ${user.name}!`);
      
      if (user.role === 'super_admin') {
        navigate('/admin/dashboard');
      } else if (!user.store_id) {
        navigate('/app/onboarding');
      } else {
        navigate(from);
      }
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Erro ao fazer login');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#1a1a2e] flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img src={LOGO_URL} alt="ADEGGA DELIVERY" className="h-24 sm:h-28 mx-auto mb-6" />
          <h1 className="text-2xl font-bold text-white">Painel do Lojista</h1>
          <p className="text-white/60 mt-2">Entre para gerenciar sua loja</p>
        </div>

        <form onSubmit={handleSubmit} className="card-adegga p-6 space-y-4">
          <div className="space-y-2">
            <label className="text-sm text-white/60">Email</label>
            <div className="relative">
              <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-white/40" />
              <Input
                type="text"
                inputMode="email"
                autoComplete="email"
                value={email}
                onChange={(e) => setEmail(e.target.value.toLowerCase())}
                placeholder="seu@email.com"
                className="pl-10 bg-[#0f0f15] border-white/10 text-white"
                data-testid="login-email"
              />
            </div>
          </div>

          <div className="space-y-2">
            <label className="text-sm text-white/60">Senha</label>
            <div className="relative">
              <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-white/40" />
              <Input
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                className="pl-10 pr-10 bg-[#0f0f15] border-white/10 text-white"
                data-testid="login-password"
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-white/40 hover:text-white"
              >
                {showPassword ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
              </button>
            </div>
          </div>

          <Button
            type="submit"
            className="w-full btn-primary h-12"
            disabled={loading}
            data-testid="login-submit"
          >
            {loading ? (
              <div className="animate-spin rounded-full h-5 w-5 border-t-2 border-b-2 border-white"></div>
            ) : (
              'Entrar'
            )}
          </Button>
        </form>

        <p className="text-center text-white/40 mt-6 text-sm">
          Ainda não tem conta?{' '}
          <a href="/app/register" className="text-[#ff6b00] hover:underline">
            Criar loja
          </a>
        </p>
      </div>
    </div>
  );
};

export default Login;
